import type { Slice } from "@reduxjs/toolkit";
import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { createActionSet } from "@somewear/model";

import type { WorkspaceState } from "../workspace.state";

export interface IWorkspaceKey {
	id: string;
	key?: string;
}

export interface IWorkspaceToken {
	id: string;
	url?: string;
}

type WorkspaceKeyOrToken = IWorkspaceKey | IWorkspaceToken;

const adapter = createEntityAdapter<WorkspaceKeyOrToken, string>({
	selectId: (workspace) => workspace.id,
});

export const workspaceKeyActions = {
	generateKey: createActionSet<undefined, IWorkspaceKey>("workspace/key/generate"),
	generateToken: createActionSet<undefined, IWorkspaceToken>("workspace/token/generate"),
};

// Rename the exports for readability in component usage
export const { selectAll: selectAllWorkspaceKeys } = adapter.getSelectors(
	(state: WorkspaceState) => state.workspaceKeys,
);

export const selectIsGeneratingKey = (state: WorkspaceState) => state.workspaceKeys.isGeneratingKey;
export const selectIsGeneratingToken = (state: WorkspaceState) =>
	state.workspaceKeys.isGeneratingToken;

export const workspaceKeysSlice: Slice = createSlice({
	name: "workspaceKeys",
	initialState: adapter.getInitialState({
		isGeneratingKey: false,
		isGeneratingToken: false,
	}),
	reducers: {
		_: () => {},
	},
	extraReducers: (builder) => {
		builder.addCase(workspaceKeyActions.generateKey.pending, (state) => {
			state.isGeneratingKey = true;
		});
		builder.addCase(workspaceKeyActions.generateKey.fulfilled, (state, action) => {
			state.isGeneratingKey = false;
			adapter.upsertOne(state, action.payload.data);
		});
		builder.addCase(workspaceKeyActions.generateKey.rejected, (state) => {
			state.isGeneratingKey = false;
		});
		builder.addCase(workspaceKeyActions.generateToken.pending, (state) => {
			state.isGeneratingToken = true;
		});
		builder.addCase(workspaceKeyActions.generateToken.fulfilled, (state, action) => {
			state.isGeneratingToken = false;
			adapter.upsertOne(state, action.payload.data);
		});
		builder.addCase(workspaceKeyActions.generateToken.rejected, (state) => {
			state.isGeneratingToken = false;
		});
	},
});
